import { render, staticRenderFns } from "./sin_upCom.vue?vue&type=template&id=45c27ee0&scoped=true"
import script from "./sin_upCom.vue?vue&type=script&lang=js"
export * from "./sin_upCom.vue?vue&type=script&lang=js"
import style0 from "./sin_upCom.vue?vue&type=style&index=0&id=45c27ee0&prod&lang=scss&scoped=true"
import style1 from "./sin_upCom.vue?vue&type=style&index=1&id=45c27ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c27ee0",
  null
  
)

export default component.exports